<!-- Botón de volver atrás - Parte superior izquierda -->
<div class="fixed top-20 left-16 z-40">
  <button type="button"
          (click)="goBack()"
          class="btn btn-ghost text-gray-700 hover:text-gray-900 hover:bg-gray-100 px-3 py-2 rounded-lg transition-colors font-medium">
    <span class="text-lg mr-1">←</span>
    <span>Volver</span>
  </button>
</div>

<div class="w-full max-w-none px-2 md:px-4 py-6 mt-16 pt-20" #exportDropdown>
  <!-- Botones de navegación -->
  <div class="flex justify-center mb-6 mt-16">
    <button id="profileButton" (click)="toggleButtonOrderSparePart('profileButton')" 
            class="px-6 py-3 mx-2 rounded-lg text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-all duration-200"
            [ngClass]="{'bg-blue-700 font-bold shadow-lg': showOrders, 'bg-blue-500': !showOrders}">
      <i class="fas fa-clipboard-list mr-2"></i> Órdenes
    </button>
    <button id="messagesButton" (click)="toggleButtonOrderSparePart('messagesButton')" 
            class="px-6 py-3 mx-2 rounded-lg text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-all duration-200"
            [ngClass]="{'bg-blue-700 font-bold shadow-lg': !showOrders, 'bg-blue-500': showOrders}">
      <i class="fas fa-tools mr-2"></i> Repuestos
    </button>
  </div>

  <!-- Barra de búsqueda y filtros - Solo mostrar cuando estamos en la sección de órdenes -->
  <div *ngIf="showOrders" class="flex flex-col md:flex-row justify-between items-center mb-6 space-y-4 md:space-y-0">
    <!-- Búsqueda -->
    <div class="w-full md:w-1/3">
      <div class="relative">
        <input 
          type="text" 
          [(ngModel)]="searchTerm"
          (keyup.enter)="applyFilter(searchTerm)"
          placeholder="Buscar..." 
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 pr-20"
        >
        <button
          *ngIf="searchTerm"
          (click)="searchTerm = ''; applyFilter('')"
          class="absolute right-10 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-red-500"
          title="Limpiar búsqueda">
          <i class="fas fa-times"></i>
        </button>
        <button 
          (click)="applyFilter(searchTerm)" 
          class="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-blue-500"
          title="Buscar">
          <i class="fas fa-search"></i>
        </button>
      </div>
    </div>

    <!-- Filtros de fecha -->
    <div class="w-full md:w-2/3 flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-2">
      <select 
        [(ngModel)]="dateFilterType"
        (change)="onDateFilterChange()"
        class="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <option value="all">Todas las fechas</option>
        <option value="today">Hoy</option>
        <option value="last7days">Últimos 7 días</option>
        <option value="last30days">Últimos 30 días</option>
        <option value="custom">Personalizado</option>
      </select>

      <!-- Fechas personalizadas -->
      <div *ngIf="dateFilterType === 'custom'" class="flex space-x-2">
        <input 
          type="date" 
          [(ngModel)]="customStartDate" 
          (change)="onDateFilterChange()"
          class="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
        <input 
          type="date" 
          [(ngModel)]="customEndDate" 
          (change)="onDateFilterChange()"
          class="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
      </div>

      <!-- Botón para limpiar filtros -->
      <button 
        *ngIf="searchTerm || dateFilterType !== 'all'"
        (click)="searchTerm = ''; dateFilterType = 'all'; applyFilter(''); applyDateFilter({startDate: undefined, endDate: undefined})"
        class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50"
      >
        Limpiar filtros
      </button>

      <!-- Solo últimos 60 días -->
      <button 
        type="button"
        (click)="onlyLast60Days = !onlyLast60Days; loadInitialOrders()"
        class="px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-colors"
        [ngClass]="onlyLast60Days ? 'bg-amber-500 hover:bg-amber-600 text-white font-medium' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'"
        title="Mostrar solo órdenes de los últimos 60 días. Los filtros aplican sobre ese subconjunto.">
        <i class="fas fa-calendar-alt mr-1"></i>
        Solo últimos 60 días
      </button>
    </div>
  </div>

  <!-- Componente de historial de órdenes -->
  <app-order-history 
    *ngIf="showOrders" 
    [searchTerm]="searchTerm"
    [loading]="loading"
    [allOrdersLoaded]="allOrdersLoaded"
    [orders]="filteredOrders"
    [startDate]="startDate"
    [endDate]="endDate"
    [totalOrders]="totalOrders"
    [dataDrivenByParent]="true"
    [onlyLast60Days]="onlyLast60Days"
    (searchFilterChanged)="applyFilter($any($event))"
    (dateFilterChanged)="applyDateFilter($any($event))"
    (loadMore)="loadMoreOrders()"
  ></app-order-history>

  <!-- Componente de historial de repuestos -->
  <app-spare-part-history 
    *ngIf="!showOrders"
  ></app-spare-part-history>
</div>